//TODO: Statsig po_request_1st_payout_method_on_finance_workspace. Remove after experiment finish
import { useEffect, useState } from 'react';
import {
    FinancialInformationFromatted,
    TaxpayerInformationFormatted,
} from '../../api/types';

export const useIsEligibleForFirstPayoutMethodExperiment = (
    data: FinancialInformationFromatted | TaxpayerInformationFormatted | {},
    isStatsigInitialized: boolean,
) => {
    const [
        isEligibleForFirstPayoutMethodExperiment,
        setIsEligibleForFirstPayoutMethodExperiment,
    ] = useState(false);

    useEffect(() => {
        if ('documentRequestStatus' in data) {
            return;
        } else {
            const hasBankAccounts = (data as FinancialInformationFromatted)
                ?.organizationInformation?.hasPayoutMethods;

            setIsEligibleForFirstPayoutMethodExperiment(
                hasBankAccounts === false,
            );
        }
    }, [data, isStatsigInitialized]);

    return { isEligibleForFirstPayoutMethodExperiment };
};
